import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceLogListComponent } from './service-log-list/service-log-list.component';
import { ServiceLogDetailComponent } from './service-log-detail/service-log-detail.component';
import { ServiceLogRoutingModule } from './service-log-routing.module';
import {ServiceLogComponent} from './service-log.component';
import {ServiceLogGuard} from './services/service-log.guard';
import {NgbDropdown, NgbModule} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  imports: [
    CommonModule,
    ServiceLogRoutingModule,
    NgbModule
  ],
  declarations: [
    ServiceLogComponent,
    ServiceLogListComponent,
    ServiceLogDetailComponent
  ],
  providers: [
    NgbDropdown,
    ServiceLogGuard,
  ]
})
export class ServiceLogModule { }
